export enum EAcquisitionType {
    NEW_ACQUISITION = "NEW_ACQUISITION",
    CROSS_SELL = "CROSS_SELL",
}

export interface ISendContractPayload {
    reference: string;
    acquisitionType: EAcquisitionType;
}

export const getStateToPayload = (reference: string, isAuthenticated: boolean): ISendContractPayload => ({
    reference,
    acquisitionType: isAuthenticated ? EAcquisitionType.CROSS_SELL : EAcquisitionType.NEW_ACQUISITION,
});
